<template>
  <div class="">
    <!-- <card back>
      <template v-slot:header>
        <h3 class="d-inline">تنظیمات صدور فاکتور</h3>
        <h6 style="font-size: small" class="d-inline float-left mx-2 ml-4 mt-2">{{ CustomerName }}</h6>
        <h6 style="font-size: small" class="d-inline text-warning float-left mt-2">اطلاعات مشـــــتری :</h6>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <h6 style="font-size: small" class="d-inline float-left mx-2 ml-4 mt-2">{{ CustomerCode }}</h6>
        <h6 style="font-size: small" class="d-inline text-warning float-left mt-2">کد مشتری :</h6>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <hr />
      </template>
      <template v-slot:content>
        <div class="row px-3">
          <div class="col-md-3 col-12">
            <small>نوع مشتری</small>
            <div class="form-control text-center">
              <div class="custom-control custom-switch">
                <small id="LbltblComboGrpId50" class="ml-2"> حقوقی</small>
                <input type="checkbox" class="custom-control-input InputText" id="Done" @change="ChangeHaghighi" v-model="DataAxios.IsHaghighi" />
                <label class="custom-control-label" for="Done"> </label>
                <small class="mr-5"> حقیقی</small>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <small v-if="DataAxios.IsHaghighi == false">نام و مشخصات فروشنده در فاکتور</small>
            <small v-if="DataAxios.IsHaghighi == true">نام و مشخصات شرکت در فاکتور</small>
            <input type="text" v-model="DataAxios.Name" class="form-control text-center" />
          </div>
          <div class="col-md-3 col-12">
            <small v-if="DataAxios.IsHaghighi == false">کد ملـــی</small>
            <small v-if="DataAxios.IsHaghighi == true">شماره ملــــی</small>
            <input type="text" maxlength="14" v-model="DataAxios.ShomareMeli" class="form-control text-center" />
          </div>
          <div class="col-md-3 col-12" v-if="DataAxios.IsHaghighi == true">
            <small>کد اقتصادی</small>
            <input type="text" maxlength="14" v-model="DataAxios.CodeEghtesadi" class="form-control text-center" />
          </div>
        </div>
        <div class="row mt-2">
          <button class="btn btn-success mr-5" @click="SetFinancial" v-if="!EditMode">ثبت تنـظیـمـات</button>
          <button class="btn btn-success mr-5" @click="EditFinancial" v-if="EditMode">ویرایش تنـظیـمـات</button>
          <button class="btn btn-warning mr-5" @click="Cancel" v-if="EditMode">انصراف</button>
        </div>
      </template>
    </card> -->

    <card >
      <template v-slot:header>
        <h5 class="d-inline"><i class="fad fa-arrow-right text-secondary ml-2 Pointer" @click="BakToDetailCustomer"></i></h5>
        <h3 class="d-inline">تنظیمات صدور فاکتور</h3>
        <h6 style="font-size: small" class="d-inline float-left mx-2 ml-4 mt-2">{{ CustomerName }}</h6>
        <h6 style="font-size: small" class="d-inline text-warning float-left mt-2">اطلاعات مشـــــتری :</h6>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <h6 style="font-size: small" class="d-inline float-left mx-2 ml-4 mt-2">{{ CustomerCode }}</h6>
        <h6 style="font-size: small" class="d-inline text-warning float-left mt-2">کد مشتری :</h6>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <hr />
      </template>
      <template v-slot:content v-if="$store.state.renderComponentGrid">
       
        <div class="row mb-1 px-2">
              <a v-if="AddMode == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddMode = 1" title="افزودن تنظیمات جدید">
                <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
              </a>
              <a v-if="AddMode != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddMode = 0;Reload()" title="لغو افزودن">
                <h4><i class="fas fa-times text-danger"></i></h4>
              </a>
          </div>
        <div v-if="AddMode!=0" class="">
           <div class="row px-3">
              <div class="col-md-3 col-12">
                <small>نوع مشتری</small>
                <div class="form-control text-center">
                  <div class="custom-control custom-switch">
                    <small id="LbltblComboGrpId50" class="ml-2"> حقیقی</small>
                    <input type="checkbox" class="custom-control-input InputText" id="Done" @change="ChangeHaghighi" v-model="DataAxios.IsHaghighi" />
                    <label class="custom-control-label" for="Done"> </label>
                    <small class="mr-5"> حقــوقی</small>
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-12">
                <small v-if="DataAxios.IsHaghighi == true">نام و مشخصات فروشنده در فاکتور</small>
                <small v-if="DataAxios.IsHaghighi == false">نام و مشخصات شرکت در فاکتور</small>
                <input type="text" v-model="DataAxios.Name" class="form-control text-center" />
              </div>
              <div class="col-md-3 col-12">
                <small v-if="DataAxios.IsHaghighi == true">کد ملـــی</small>
                <small v-if="DataAxios.IsHaghighi == false">شماره ملــــی</small>
                <input type="text" maxlength="14" v-model="DataAxios.ShomareMeli" class="form-control text-center" />
              </div>
              <div class="col-md-3 col-12" v-if="DataAxios.IsHaghighi == false">
                <small>کد اقتصادی</small>
                <input type="text" maxlength="14" v-model="DataAxios.CodeEghtesadi" class="form-control text-center" />
              </div>
          </div>
          <div class="row mt-2">
            <button class="btn btn-success mr-5" @click="SetFinancial" v-if="AddMode==1">ثبت تنـظیـمـات</button>
            <button class="btn btn-success mr-5" @click="EditFinancial" v-if="AddMode==-1">ویرایش تنـظیـمـات</button>
            <button class="btn btn-warning mr-5" @click="Cancel" v-if="AddMode==-1">انصراف</button>
          </div>
        </div>
        <div v-if="AddMode==0" class="row px-3">
          <bnp-grid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="true">
            <template slot="Archive" slot-scope="props">
              <span class="font-smaller"> {{ props.props.Archive == true ? 'بایگانی شده' : 'فعال' }}</span>
            </template>
            <template slot="action-slot" slot-scope="props">
              <a href="javascript:;" class="mr-2 badge no-print"
                ><h5><span class="fas fa-marker text-secondary hover-warning" @click="OnEdit(props.props)" title="ویرایش"></span></h5
              ></a>
              <button v-if="props.props.Archive == true" class="btn btn-success" @click="Archive(props.props.Id, props.props)">فعال کردن</button>
              <button v-if="props.props.Archive == false" class="btn btn-warning" @click="Archive(props.props.Id, props.props)">بایگانی کردن</button>
            </template>
          </bnp-grid>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import BnpGrid from '../../../../components/BnpGrid/BnpGrid.vue'
import Card from '../../../../components/Card/Card.vue'
export default {
  components: { Card, BnpGrid },
    data(){
        return{
            DataAxios:
             {
                IsHaghighi:true,
                Id : 0 ,
                Name : '' ,
                tblComboGrpId50CustomerFactorType : 2001 ,
                Archive : false ,
                ShomareMeli : '' ,
                CodeEghtesadi : '' ,
                tblCustomerId : this.CustomerId ,
                tblUserGrpIdInsert : this.$session.get('UserInfo').tblUserGrpId ,
                tblUserGrpIdLastEdit : null ,
                DateTimeInsert : '' ,
                DateTimeLastEdit : '' ,
            },
            Rows: [],
            Column:[
                { name: 'tblComboGrpId50Name', label: 'نوع مشتری', visibility: true },
                { name: 'Name', label: 'بنام', visibility: true },
                { name: 'ShomareMeli', label: 'شماره ملی | کد ملی', visibility: true },
                { name: 'CodeEghtesadi', label: 'شماره اقتصادی', visibility: true },
                { name: 'Archive', label: 'وضعیت', visibility: true },
            ],
            EditMode:false,
            AddMode: 0,


        }
    },
    props: ['tblCustomerId','CustomerCode','CustomerName'],
    mounted() {
        this.DataAxios.tblCustomerId= this.tblCustomerId
        this.GetFinancial(this.tblCustomerId);
    },
    methods: {
        ChangeHaghighi(){
            this.DataAxios.IsHaghighi==true?this.DataAxios.tblComboGrpId50CustomerFactorType=2001:this.DataAxios.tblComboGrpId50CustomerFactorType=2002;
            this.$store.state.renderComponentGrid=false
            this.$nextTick(() => {
            this.$store.state.renderComponentGrid=true
            })

        },
        SetFinancial(){
            let DataAxios_SetData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerFinancialInvoice/SetCustomerFinancialInvoice', Token: this.$session.get('Token') }
            DataAxios_SetData.ArryfildValue=this.DataAxios
            // console.log(this.DataAxios);
            this.$PostData(DataAxios_SetData)
            .then((data) => {
                    this.GetFinancial(this.tblCustomerId);
                      this.AddMode=0
                    if (data.status=="Ok") {
                      this.$toasted.success('تنظیمات شما با موفقیت ثبت کردید',{duration:2000})
                    }
                    else{
                      this.$toasted.error('خطای در ثبت تنظیمات مالی به وجود آمده ، لطفا کمی بعد دوباره تلاش کنید',{duration:2000})
                    }

            })
            .finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            })
        },
        GetFinancial(Id){
            let DataAxios_GetData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerFinancialInvoice/GetCustomerFinancialInvoice', Token: this.$session.get('Token') }
            DataAxios_GetData.ArryfildValue.Id=Id
            this.$PostData(DataAxios_GetData)
            .then((data) => {
                this.Rows=data
            })
            .finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            })
        },
        Archive(Id,row){
            let DataAxios_ArciveData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerFinancialInvoice/ArchiveCustomerFinancialInvoice', Token: this.$session.get('Token') }
            DataAxios_ArciveData.ArryfildValue={Id:Id,tblCustomerId:row.tblCustomerId}
            this.$PostData(DataAxios_ArciveData)
            .then((data) => {
                if (data.status== 'Ok') {
                    this.GetFinancial(this.tblCustomerId);
                }
                else{
                    this.$toasted.error('ردیف دیگری در وضعیت فعال قرار دارد، ابتدا آن را غیر فعال و دوباره تلاش کنید',{duration:2000})
                }
            })
            .finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            })
        },
        OnEdit(row){
            this.DataAxios=row
            if (row.tblComboGrpId50CustomerFactorType==2001) {
                this.DataAxios.IsHaghighi=true
            }
            if (row.tblComboGrpId50CustomerFactorType==2002) {
                this.DataAxios.IsHaghighi=false
            }
            this.EditMode=true
            this.AddMode=-1
        },
        Cancel(){
            this.DataAxios= {
                IsHaghighi:true,
                Id : 0 ,
                Name : '' ,
                tblComboGrpId50CustomerFactorType : 2001 ,
                Archive : false ,
                ShomareMeli : '' ,
                CodeEghtesadi : '' ,
                tblCustomerId : this.CustomerId ,
                tblUserGrpIdInsert : this.$session.get('UserInfo').tblUserGrpId ,
                tblUserGrpIdLastEdit : 0 ,
                DateTimeInsert : '' ,
                DateTimeLastEdit : '' ,
            },
            this.EditMode=false
            this.AddMode=0
        },
        EditFinancial(){
          this.DataAxios.tblUserGrpIdLastEdit= this.$session.get('UserInfo').tblUserGrpId
            let DataAxios_SetData = { ArryfildValue: {}, Method: 'post', Action: 'CustomerFinancialInvoice/EditCustomerFinancialInvoice', Token: this.$session.get('Token') }
            DataAxios_SetData.ArryfildValue=this.DataAxios
            // console.log(this.DataAxios);
            this.$PostData(DataAxios_SetData)
            .then((data) => {
                    this.GetFinancial(this.tblCustomerId);
                    this.AddMode=0;
                    this.$toasted.success('تغییرات با موفق اعمال گردید .',{duration:2000})

            })
            .finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                })
            })
        },
        BakToDetailCustomer(){
            this.$router.push({name:"DetailCustomer",params:{tblCustomerId:this.tblCustomerId,activeTab:0}})
        },
        Reload(){
          this.DataAxios={
                IsHaghighi:true,
                Id : 0 ,
                Name : '' ,
                tblComboGrpId50CustomerFactorType : 2001 ,
                Archive : false ,
                ShomareMeli : '' ,
                CodeEghtesadi : '' ,
                tblCustomerId : this.CustomerId ,
                tblUserGrpIdInsert : this.$session.get('UserInfo').tblUserGrpId ,
                tblUserGrpIdLastEdit : null ,
                DateTimeInsert : '' ,
                DateTimeLastEdit : '' ,
            }
            this.AddMode=0;
        }
    }
}
</script>
<style scoped></style>
